// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._SHJ6uBT4XA39ztO{display:flex;flex-direction:column;justify-content:space-between;height:100%}._SHJ6uBT4XA39ztO .k4yrELTevoKbPPz5{width:100%;height:248px;display:grid;place-items:center}.ggiGhkR5_fYajKu4{border-radius:4px;background-color:var(--py-neutral-1);padding:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartContainer": `_SHJ6uBT4XA39ztO`,
	"factorsPolygon": `k4yrELTevoKbPPz5`,
	"selectionChip": `ggiGhkR5_fYajKu4`
};
export default ___CSS_LOADER_EXPORT___;
